// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/app/frontend/src/models/config';
import model_2 from '/app/frontend/src/models/tags';
import model_3 from '/app/frontend/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'config', model: model_1 },
model_2: { namespace: 'tags', model: model_2 },
model_3: { namespace: '@@initialState', model: model_3 },
} as const
